import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class StatServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getDetailed(params) {
    return this.http.get('/calltracking-statistics', { params: params });
  }
}

export const StatService = new StatServiceClass({
  api_version: 2,
  resource: ''
});
